var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector54(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 309,
    viewBox: "0 0 86 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M327.934 307.659C304.546 288.743 300.84 284.624 286.024 265.216C282.393 260.461 276.681 251.217 271.226 239.799C269.592 236.383 268.109 232.994 266.75 229.654C257.057 205.746 255.688 178.963 257.94 152.512C263.69 85.0233 227.158 24.1114 171.847 6.35408C116.441 -11.4317 54.9147 17.8285 24.8928 63.4887C20.9869 69.4299 3.75681 97.4658 1.20985 128.225C-6.85872 225.345 87.2175 264.153 230.361 293.536C233.145 294.106 246.403 296.279 249.216 296.668L327.944 307.668L327.934 307.659Z",
    stroke: "#1E1E22",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector54);
export default __webpack_public_path__ + "static/media/vector5-4.062e1cd7f1b56395c9f608ac70abe5b9.svg";
export { ForwardRef as ReactComponent };